import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[trimWhitespace]',
})
export class TrimWhitespaceDirective {

  constructor(private el: ElementRef,
              @Optional() private ngControl: NgControl
  ) { }

  @HostListener('blur') onBlur(): void {
    if (this.ngControl?.control && this.el?.nativeElement?.value) {
      this.ngControl.control.setValue(this.el.nativeElement.value.trim());
    }
  }
}
